import NetInfo from '@react-native-community/netinfo';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import React, {useEffect, useState} from 'react';
import {
  BackHandler,
  Dimensions,
  Linking,
  Platform,
  SafeAreaView,
  View,
} from 'react-native';
import SplashScreen from 'react-native-splash-screen';
import {connect} from 'react-redux';
import url from './data/config';
import Popup from './presentations/components/Modal/Popup/Popup';
import {Navigation} from './presentations/navigation';
import mapDispatchToProps from './services/redux/mapDispatchToProps';

import mapStateToProps from './services/redux/mapStateToProps';

const initialRoute = 'Home';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function App(props: any) {
  const {initialRouteUser} = props;
  const [isConnected, setIsConnected] = useState(true);
  const [isConnectedToServer, setIsConnectedToServer] = useState(true);

  useEffect(() => {
    Platform.OS !== 'web' && SplashScreen.hide();
    NetInfo.addEventListener(state => {
      setIsConnected(state.isConnected ?? false);
    });
    isServerReachable();
  }, []);

  const showServerDialog = () => {
    const serverErrorDialog = window.confirm(
      "Nous rencontrons des problèmes de connexion au serveur . S'il vous plait, réessayer plus tard ou vérifier votre connexion internet !",
    );
    if (serverErrorDialog == true) {
      isServerReachable();
    } else {
      isServerReachable();
    }
  };

  // ce config est requis si initialisation de dayjs à partir de format autre que Date()
  dayjs.extend(customParseFormat);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  const isServerReachable = async () => {
    const timeout = new Promise((resolve, reject) => {
      setTimeout(reject, 5000, 'Request timed out');
    });

    const request = fetch(url.apiDocs);
    try {
      Linking.canOpenURL(url.apiDocs).then(connection => {
        if (!connection) {
          setIsConnectedToServer(false);
        } else {
          fetch(url.apiDocs).then(res => {
            res.status === 404 && initialRouteUser('PageNotFound', () => {});
            res.status !== 200 && res.status !== 404
              ? initialRouteUser('ServeurIndisponible', () => {})
              : initialRouteUser('home', () => {});
            setIsConnectedToServer(res.status !== 200 ? false : true);
          });
        }
      });
      await Promise.race([timeout, request]);
      return setIsConnectedToServer(true);
    } catch {
      if (Platform.OS === 'web') {
        // TODO: uncomment
        showServerDialog();
      } else {
        return '';
      }
    }
  };

  const exit = () => {
    setIsConnected(true);
    BackHandler.exitApp();
  };
  return (
    <SafeAreaView style={{flex: 1}}>
      <Navigation initialRoute={initialRoute} />
      {!isConnected && (
        <View
          style={{
            height: Dimensions.get('screen').height,
            maxWidth: Dimensions.get('screen').width,
            position: 'absolute',
            bottom: 0,
            backgroundColor: 'rgba(52, 52, 52, 0.8)',
            flex: 1,
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Popup
            title="Se connecter à un réseau"
            content="Pour utiliser l'application veuillez vous connecter à internet "
            exit={exit}
          />
        </View>
      )}
      {!isConnectedToServer && (
        <View
          style={{
            height: Dimensions.get('screen').height,
            maxWidth: Dimensions.get('screen').width,
            position: 'absolute',
            bottom: 0,
            backgroundColor: 'rgba(52, 52, 52, 0.8)',
            flex: 1,
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Popup
            title="Problème interne au serveur"
            content="Le serveur est momentanément indisponible. Veuillez réessayer plus tard."
            exit={exit}
          />
        </View>
      )}
    </SafeAreaView>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
